import { getJobList } from './GetJobList';
import { getRecommendedRates, resolveRecommendedRate, resolveRateEntry } from './GetRecommendedRates';

/**
 * Jobs Service
 * Provides business logic layer for jobs operations
 */
export const JobsService = {
  getJobList,
  getRecommendedRates,
};

export { resolveRecommendedRate, resolveRateEntry };
